export default __webpack_public_path__ + "static/media/picto-scan-petit.3b85d179.png";